import { render } from "./UserAgreementView.vue?vue&type=template&id=00b93af6&ts=true"
import script from "./UserAgreementView.vue?vue&type=script&lang=ts"
export * from "./UserAgreementView.vue?vue&type=script&lang=ts"

import "./UserAgreementView.vue?vue&type=style&index=0&id=00b93af6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__